// third-party
import { FormattedMessage } from "react-intl";
import financementIcon from "../assets/icons/financement.svg";

const icons = {
  tamwil: () => <img src={financementIcon} alt="icône financement" />,
};

const tamwil = {
  id: "tamwil",
  title: <FormattedMessage id="tamwil" defaultMessage="Tamwil" />,
  type: "group",
  url: "/tamwil",
  icon: icons.tamwil,
};

export default tamwil;
